import { useState, useContext } from 'react';
import classes from './progressDialog.module.scss';
import i18n from '../../../utils/i18n';

import sittingFigure from '../../../images/sitting-figure.svg';
import checker from '../../../images/checker.svg';
import generalRadioButtonOn from '../../../images/general-radiobutton-on.svg';
import generalRadioButtonOff from '../../../images/general-radiobutton-off.svg';

import CustomButton from '../../components/CustomButton';

import ProfileTabContext from '../context/ProfileTabContext';

const ProgressDialog = ({ setOpen, tabs, providerData }) => {
	const [activeTab, setActiveTab] = useState('profilesettings');
	const { activeProfileTab, setActiveProfileTab } =
		useContext(ProfileTabContext);

	const renderContent = (activeTab) => {
		switch (activeTab) {
			case 'profilesettings':
				return (
					<div className={classes.contentRightContainer}>
						<>
							<h2 className={classes.contentRightHeader}>
								{i18n.t('onboarding.dialogcontentheader1')}
							</h2>
							<p className={classes.contentRightText}>
								{providerData.provider_onboarding.profilesettings_flow
									.iscompleted
									? i18n.t('onboarding.dialogcontenttext6')
									: i18n.t('onboarding.dialogcontenttext1')}
							</p>
						</>
						<div style={{ marginTop: 'auto' }}>
							<CustomButton
								buttonName={
									providerData.provider_onboarding.profilesettings_flow
										.iscompleted
										? i18n.t('onboarding.modify')
										: i18n.t('onboarding.getstarted')
								}
								buttonColor={
									providerData.provider_onboarding.profilesettings_flow
										.iscompleted
										? 'rgba(250, 252, 254, 1)'
										: 'rgba(28, 50, 243, 1)'
								}
								hoverColor='#e0e0ff'
								titleColor={
									providerData.provider_onboarding.profilesettings_flow
										.iscompleted
										? 'rgba(75, 80, 128, 1)'
										: '#ffffff'
								}
								titleHoverColor='#1c32f3'
								borderColor={
									providerData.provider_onboarding.profilesettings_flow
										.iscompleted
										? 'rgba(227, 229, 233, 1)'
										: ''
								}
								borderWidth={
									providerData.provider_onboarding.profilesettings_flow
										.iscompleted
										? '1px'
										: ''
								}
								width='100%'
								height='44px'
								padding='12px'
								onClick={(e) => {
									setActiveProfileTab(activeTab);

									setOpen(false);
								}}
							/>
						</div>
					</div>
				);
			case 'companyinfo':
				return (
					<div className={classes.contentRightContainer}>
						<>
							<h2 className={classes.contentRightHeader}>
								{i18n.t('onboarding.dialogcontentheader2')}
							</h2>
							<p className={classes.contentRightText}>
								{providerData.provider_onboarding.companyinfo_flow.iscompleted
									? i18n.t('onboarding.dialogcontenttext6')
									: i18n.t('onboarding.dialogcontenttext2')}
							</p>
						</>
						<div style={{ marginTop: 'auto' }}>
							<CustomButton
								buttonName={
									providerData.provider_onboarding.companyinfo_flow.iscompleted
										? i18n.t('onboarding.modify')
										: i18n.t('onboarding.getstarted')
								}
								buttonColor={
									providerData.provider_onboarding.companyinfo_flow.iscompleted
										? 'rgba(250, 252, 254, 1)'
										: 'rgba(28, 50, 243, 1)'
								}
								hoverColor='#e0e0ff'
								titleColor={
									providerData.provider_onboarding.companyinfo_flow.iscompleted
										? 'rgba(75, 80, 128, 1)'
										: '#ffffff'
								}
								titleHoverColor='#1c32f3'
								borderColor={
									providerData.provider_onboarding.companyinfo_flow.iscompleted
										? 'rgba(227, 229, 233, 1)'
										: ''
								}
								borderWidth={
									providerData.provider_onboarding.companyinfo_flow.iscompleted
										? '1px'
										: ''
								}
								width='100%'
								height='44px'
								padding='12px'
								onClick={(e) => {
									setActiveProfileTab(activeTab);
									setOpen(false);
								}}
							/>
						</div>
					</div>
				);
			case 'clientfilters':
				return (
					<div className={classes.contentRightContainer}>
						<>
							<h2 className={classes.contentRightHeader}>
								{i18n.t('onboarding.dialogcontentheader3')}
							</h2>
							<p className={classes.contentRightText}>
								{providerData.provider_onboarding.clientfilters_flow.iscompleted
									? i18n.t('onboarding.dialogcontenttext6')
									: i18n.t('onboarding.dialogcontenttext3')}
							</p>
						</>
						<div style={{ marginTop: 'auto' }}>
							<CustomButton
								buttonName={
									providerData.provider_onboarding.clientfilters_flow
										.iscompleted
										? i18n.t('onboarding.modify')
										: i18n.t('onboarding.getstarted')
								}
								buttonColor={
									providerData.provider_onboarding.clientfilters_flow
										.iscompleted
										? 'rgba(250, 252, 254, 1)'
										: 'rgba(28, 50, 243, 1)'
								}
								hoverColor='#e0e0ff'
								titleColor={
									providerData.provider_onboarding.clientfilters_flow
										.iscompleted
										? 'rgba(75, 80, 128, 1)'
										: '#ffffff'
								}
								titleHoverColor='#1c32f3'
								borderColor={
									providerData.provider_onboarding.clientfilters_flow
										.iscompleted
										? 'rgba(227, 229, 233, 1)'
										: ''
								}
								borderWidth={
									providerData.provider_onboarding.clientfilters_flow
										.iscompleted
										? '1px'
										: ''
								}
								width='100%'
								height='44px'
								padding='12px'
								onClick={(e) => {
									setActiveProfileTab(activeTab);
									setOpen(false);
								}}
							/>
						</div>
					</div>
				);
			case 'services':
				return (
					<div className={classes.contentRightContainer}>
						<>
							<h2 className={classes.contentRightHeader}>
								{i18n.t('onboarding.dialogcontentheader4')}
							</h2>
							<p className={classes.contentRightText}>
								{providerData.provider_onboarding.services_flow.iscompleted
									? i18n.t('onboarding.dialogcontenttext6')
									: i18n.t('onboarding.dialogcontenttext4')}
							</p>
						</>
						<div style={{ marginTop: 'auto' }}>
							<CustomButton
								buttonName={
									providerData.provider_onboarding.services_flow.iscompleted
										? i18n.t('onboarding.modify')
										: i18n.t('onboarding.getstarted')
								}
								buttonColor={
									providerData.provider_onboarding.services_flow.iscompleted
										? 'rgba(250, 252, 254, 1)'
										: 'rgba(28, 50, 243, 1)'
								}
								hoverColor='#e0e0ff'
								titleColor={
									providerData.provider_onboarding.services_flow.iscompleted
										? 'rgba(75, 80, 128, 1)'
										: '#ffffff'
								}
								titleHoverColor='#1c32f3'
								borderColor={
									providerData.provider_onboarding.services_flow.iscompleted
										? 'rgba(227, 229, 233, 1)'
										: ''
								}
								borderWidth={
									providerData.provider_onboarding.services_flow.iscompleted
										? '1px'
										: ''
								}
								width='100%'
								height='44px'
								padding='12px'
								onClick={(e) => {
									setActiveProfileTab(activeTab);
									setOpen(false);
								}}
							/>
						</div>
					</div>
				);
			case 'pricing':
				return (
					<div className={classes.contentRightContainer}>
						<>
							<h2 className={classes.contentRightHeader}>
								{i18n.t('onboarding.dialogcontentheader5')}
							</h2>
							<p className={classes.contentRightText}>
								{providerData.provider_onboarding.pricing_flow.iscompleted
									? i18n.t('onboarding.dialogcontenttext6')
									: i18n.t('onboarding.dialogcontenttext5')}
							</p>
						</>
						<div style={{ marginTop: 'auto' }}>
							<CustomButton
								buttonName={
									providerData.provider_onboarding.pricing_flow.iscompleted
										? i18n.t('onboarding.modify')
										: i18n.t('onboarding.getstarted')
								}
								buttonColor={
									providerData.provider_onboarding.pricing_flow.iscompleted
										? 'rgba(250, 252, 254, 1)'
										: 'rgba(28, 50, 243, 1)'
								}
								hoverColor='#e0e0ff'
								titleColor={
									providerData.provider_onboarding.pricing_flow.iscompleted
										? 'rgba(75, 80, 128, 1)'
										: '#ffffff'
								}
								titleHoverColor='#1c32f3'
								borderColor={
									providerData.provider_onboarding.pricing_flow.iscompleted
										? 'rgba(227, 229, 233, 1)'
										: ''
								}
								borderWidth={
									providerData.provider_onboarding.pricing_flow.iscompleted
										? '1px'
										: ''
								}
								width='100%'
								height='44px'
								padding='12px'
								onClick={(e) => {
									setActiveProfileTab(activeTab);
									setOpen(false);
								}}
							/>
						</div>
					</div>
				);
			default:
				return (
					<div className={classes.contentRightContainer}>
						<>
							<h2 className={classes.contentRightHeader}>
								{i18n.t('onboarding.dialogcontentheader1')}
							</h2>
							<p className={classes.contentRightText}>
								{providerData.provider_onboarding.profilesettings_flow
									.iscompleted
									? i18n.t('onboarding.dialogcontenttext6')
									: i18n.t('onboarding.dialogcontenttext1')}
							</p>
						</>
						<div style={{ marginTop: 'auto' }}>
							<CustomButton
								buttonName={
									providerData.provider_onboarding.profilesettings_flow
										.iscompleted
										? i18n.t('onboarding.modify')
										: i18n.t('onboarding.getstarted')
								}
								buttonColor={
									providerData.provider_onboarding.profilesettings_flow
										.iscompleted
										? 'rgba(250, 252, 254, 1)'
										: 'rgba(28, 50, 243, 1)'
								}
								hoverColor='#e0e0ff'
								titleColor={
									providerData.provider_onboarding.profilesettings_flow
										.iscompleted
										? 'rgba(75, 80, 128, 1)'
										: '#ffffff'
								}
								titleHoverColor='#1c32f3'
								borderColor={
									providerData.provider_onboarding.profilesettings_flow
										.iscompleted
										? 'rgba(227, 229, 233, 1)'
										: ''
								}
								borderWidth={
									providerData.provider_onboarding.profilesettings_flow
										.iscompleted
										? '1px'
										: ''
								}
								width='100%'
								height='44px'
								padding='12px'
								onClick={(e) => {
									setActiveProfileTab(activeTab);
									setOpen(false);
								}}
							/>
						</div>
					</div>
				);
		}
	};

	const setTab = (event) => {
		setActiveTab(event.target.id);
	};

	return (
		<div className={classes.dialogContainer}>
			<div className={classes.dialogHeader}>
				<h1>{i18n.t('onboarding.letsstart')}</h1>
				<img
					src={checker}
					alt='close button'
					className={classes.closeButton}
					onClick={() => setOpen(false)}
				/>
			</div>
			<div className={classes.dialogContent}>
				<div className={classes.contentLeft}>
					<div className={classes.tabsList}>
						{tabs.map((e, idx) => {
							return (
								<p
									id={e.id}
									className={
										classes.tab +
										' ' +
										(activeTab === e.id ? classes.active : '')
									}
									onClick={(e) => {
										setActiveTab(e.target.id);
									}}
									key={idx}>
									<img
										id={e.id}
										alt='check mark'
										src={
											providerData?.provider_onboarding[`${e.id}_flow`]
												?.iscompleted
												? generalRadioButtonOn
												: generalRadioButtonOff
										}
									/>{' '}
									<span
										id={e.id}
										className={
											providerData?.provider_onboarding[`${e.id}_flow`]
												?.iscompleted
												? classes.complete
												: null
										}>
										{e.label}
									</span>
								</p>
							);
						})}
					</div>
					<img
						src={sittingFigure}
						alt='sitting figure'
						className={classes.sittingFigure}
					/>
				</div>
				<div className={classes.contentRight}>{renderContent(activeTab)}</div>
			</div>
		</div>
	);
};

export default ProgressDialog;
